<template>
    <div class="editor-wrap">
        <Toolbar :defaultConfig="toolbarConfig" :editor="editor" :mode="mode"
            style="border: 1px solid #e9e9eb;width:100%;" />
        <Editor :defaultConfig="editorConfig"
            style="border: 1px solid #e9e9eb;width:100%;border-top:0 none ;height:320px;" v-model="valueHtml"
            @onCreated="handleCreated" @onChange="handleChange" />
    </div>
</template>
<script>
import '@wangeditor/editor/dist/css/style.css';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';

export default {
    components:{
        Editor,
        Toolbar,
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            editor: null,
            toolbarConfig: {
                excludeKeys: [
                    "group-image",
                    'group-video',
                    'fullScreen',
                    'insertTable',
                    'codeBlock',
                    'insertLink',
                    'redo',
                    'undo',
                    "todo",
                    "emotion"
                ]
            },
            editorConfig: { 
                placeholder: '示例：关于高血压患者问卷调查',
                readOnly: this.disabled // 根据 props 设置只读
            },
            valueHtml: ''
        };
    },
    watch: {
        value(valueHtml) {
            this.valueHtml = valueHtml
        },
        disabled(newVal) {
            // 当 disabled 状态变化时，更新编辑器只读状态
            if (this.editor) {
                this.editor.setConfig({
                    readOnly: newVal
                });
                // 更新工具栏禁用状态
                this.editor.toolbarConfig.readOnly = newVal;
                // 重新渲染工具栏
                if (this.editor.toolbar) {
                    this.editor.toolbar.update();
                }
            }
        }
    },
    created() {
        // 同步初始值
        this.valueHtml = this.value;
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    },
    methods: {
        handleCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
            // 初始状态下如果 disabled 为 true，设置只读
            if (this.disabled) {
                this.editor.setConfig({
                    readOnly: true
                });
                this.editor.toolbarConfig.readOnly = true;
            }
        },
        handleChange(data) {
            // 如果处于 disabled 状态，不触发 change 事件
            if (this.disabled) return;
            
            console.log(data.children[0].children[0].text==='')
            // if(this.valueHtml == '<p><br></p>') return;
            this.$emit('changeData',data.children[0].children[0].text===''?'<p><br></p>':this.valueHtml)
        }
    }
};
</script>

<style scoped>
.editor-wrap {
    height: 362px;
    border-bottom: 1px solid #e9e9eb;
    margin:10px 20px;
    font-size: initial;
    text-align: initial;
    line-height: inherit;
}
</style>